import { format } from 'date-fns';

import { LanguageKey } from '../../context';
import { GetTripDetailsResponse } from '../../services';
import { currentEnvAppConfig } from '../env';
import { IdTokenIdentity } from '../jwt/decode';
import { getAddress, isDateDefined } from '../trips';
import { mapAgreementIdToRoxx } from './agreement-id-mapping';

const BASE_URL = currentEnvAppConfig.roxxLink;
const API_KEY = currentEnvAppConfig.roxxApiKey;

const FEEDBACK_URL_TIME_FORMAT = 'yyyyMMddHHmmss';

enum FeedbackLang {
  En = 'eng',
  Sv = 'sv',
  // Doesn't seem to exist
  No = 'no',
}

function buildUrl(
  baseUrl: string,
  searchParams: Record<string, string | number | null | undefined>
) {
  const url = new URL(baseUrl);
  Object.entries(searchParams).forEach(([key, value]) => {
    if (value != null) {
      url.searchParams.append(key, `${value}`);
    }
  });
  return url;
}

const getFeedbackLanguage = (lang: LanguageKey) => {
  switch (lang) {
    case 'sv':
      return FeedbackLang.Sv;
    case 'no':
      return FeedbackLang.No;
    case 'en':
    default:
      return FeedbackLang.En;
  }
};

interface BuildFeedbackUrlConfig {
  baseUrl?: string;
  apiKey?: string;
}

export function buildFeedbackUrl(
  trip: GetTripDetailsResponse,
  identity: IdTokenIdentity | null | undefined,
  lang: LanguageKey,
  config: BuildFeedbackUrlConfig = {}
) {
  const baseUrl = config.baseUrl ?? BASE_URL;
  const apiKey = config.apiKey ?? API_KEY;
  return buildUrl(baseUrl, {
    // Omit entirely rather than encode the Unix epoch when pickUpDateTime is missing (ENB-2345).
    tripdatetime: isDateDefined(trip.pickUpDateTime)
      ? format(new Date(trip.pickUpDateTime), FEEDBACK_URL_TIME_FORMAT)
      : undefined,
    traveller: `${trip.firstName} ${trip.lastName}`,
    submitter: identity?.displayName,
    subemail: identity?.email,
    carno: trip.fixedCar,
    agreementid: mapAgreementIdToRoxx(trip.agreementID),
    companyno: trip.companyNo,
    bookrefno: trip.id,
    driverno: trip.fixedDriver,
    travid: trip.personID,
    pickup: getAddress(trip.addresses, 'pickup'),
    dropoff: getAddress(trip.addresses, 'destination'),
    lang: getFeedbackLanguage(lang),
    key: apiKey,
  });
}
